/*
  Eva global mute: single source of truth for whether ANY audio on the
  site should be audible. Loaded first (before sound-engine.js and every
  other audio-owning script, see layout/theme.liquid's script order) so
  window.EvaMute exists before any other file's top-level init code runs.

  localStorage key evaSoundMuted already existed (sound-engine.js's own
  UI-blip mute) -- this file doesn't rename it, just centralizes reading/
  writing it so every audio source (radio music + mechanical sounds,
  Källare EVATV song/film audio/insert-eject sounds, UI blips, any future
  audio) shares ONE implementation instead of copying the same
  localStorage check, per Per's spec (2026-08-02).

  SILENCE, DON'T STOP: applyToElement sets element.muted, never touches
  play/pause/currentTime/volume -- muting can't disturb playback position
  or another system's own volume/gain logic (ducking, per-track
  loudness-normalization gain, etc.), and unmuting resumes exactly where
  the element already was, at whatever volume it already had.
*/
(function () {
  var KEY = 'evaSoundMuted';
  var EVENT = 'eva:sound:muted';

  function isMuted() {
    try { return localStorage.getItem(KEY) === 'muted'; } catch (e) { return false; }
  }

  function setMuted(muted) {
    try { localStorage.setItem(KEY, muted ? 'muted' : 'unmuted'); } catch (e) {}
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { muted: !!muted } }));
  }

  // Sets the element's current muted state and keeps it in sync with
  // every future toggle for the life of the element. Call once, right
  // after creating the Audio/video element -- covers "elements created
  // after mute was set must start muted" for free, since isMuted() is
  // read immediately.
  function applyToElement(el) {
    if (!el) { return; }
    el.muted = isMuted();
    document.addEventListener(EVENT, function (e) {
      el.muted = !!(e.detail && e.detail.muted);
    });
  }

  window.EvaMute = {
    KEY: KEY,
    EVENT: EVENT,
    isMuted: isMuted,
    setMuted: setMuted,
    applyToElement: applyToElement
  };
})();
